<script>
  let { activeTab = 'dashboard' } = $props()

  const tabs = [
    { id: 'dashboard', label: '대시보드', href: '/admin' },
    { id: 'users', label: '사용자', href: '/admin/users' },
    { id: 'posts', label: '게시글', href: '/admin/posts' },
    { id: 'comments', label: '댓글', href: '/admin/comments' },
    { id: 'reports', label: '신고', href: '/admin/reports' },
    { id: 'content_reviews', label: '콘텐츠 심사', href: '/admin/content_reviews' },
    { id: 'organizations', label: '기관', href: '/admin/organizations' },
    { id: 'boards', label: '게시판', href: '/admin/boards' },
    { id: 'categories', label: '카테고리', href: '/admin/categories' },
    { id: 'threads', label: 'Threads', href: '/admin/threads_posts' },
    { id: 'audit_logs', label: '감사 로그', href: '/admin/audit_logs' },
    { id: 'vibestudy_comments', label: 'VibeStudy: 댓글', href: '/admin/community/comments' },
    { id: 'vibestudy_surveys', label: 'VibeStudy: 설문', href: '/admin/community/surveys' },
    { id: 'vibestudy_members', label: 'VibeStudy: 멤버', href: '/admin/community/members' },
  ]
</script>

<div class="mb-6">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-3">
      <h1 class="text-h1 text-content">관리자</h1>
      <span class="badge badge-error">ADMIN</span>
    </div>
    <a href="/" class="text-body2 text-content-tertiary hover:text-primary transition-colors">← 사이트로 돌아가기</a>
  </div>
  <div class="flex items-center gap-1 border-b border-default -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 overflow-x-auto">
    {#each tabs as tab}
      <a
        href={tab.href}
        class="px-4 py-3 text-label whitespace-nowrap cursor-pointer transition-colors
          {activeTab === tab.id
            ? 'text-primary border-b-2 border-primary font-semibold'
            : 'text-content-tertiary hover:text-gray-900 dark:hover:text-dark-text-high'
          }"
      >{tab.label}</a>
    {/each}
  </div>
</div>
